import { get } from 'lodash';

export const getNameByLocal = (obj, locale, path) => {
  const namePath = path || 'name';

  return get(obj, `${namePath}[${locale}]`) || get(obj, `${namePath}.en`);
};
export const getMlNameByLocal = (obj, locale) => get(obj, `attributes.mlName[${locale}]`) || get(obj, 'attributes.mlName.en');
